"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisibilityLevelHelper = void 0;
const typescript_1 = require("typescript");
class VisibilityLevelHelper {
    static getLevel(node) {
        const accessModifierIndex = 0;
        const mods = node.modifiers;
        if (mods) {
            switch (mods[accessModifierIndex].kind) {
                case typescript_1.SyntaxKind.PrivateKeyword: return "private";
                case typescript_1.SyntaxKind.ProtectedKeyword: return "protected";
            }
        }
        return "public";
    }
}
exports.VisibilityLevelHelper = VisibilityLevelHelper;
